import { BaseObjectDto } from '../../../core/business-objects/base-object/base-object.dto';

export class AccountObjectDto extends BaseObjectDto {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/account-object/account-object.dto.ts